import { getOrderGZHInfo } from './api';

const defaulTeacherAvatar = require('../assets/image/teacher_sel.png');
const defaulTeacherName = '助教老师';

/**
 * 补齐教师信息
 */
export const teacherInfoPatch = (teacherInfo: any) => {
    if (!teacherInfo) {
        return teacherInfo;
    }
    // 如果没有头像
    if (!teacherInfo.weChatAvatar) {
        teacherInfo.weChatAvatar = defaulTeacherAvatar;
    }

    // 如果没有老师名
    if (!teacherInfo.weChatName) {
        teacherInfo.weChatName = defaulTeacherName;
    }

    return teacherInfo;
};

/**
 * @params
 * asyncApi: 調用接口方法
 * orderToken: 订单号
 * data: 助教数据
 * count: 轮询次数
 *
 */

/**
 * 重试指定方法
 * @param fn 重试方法(回调会添加参数retrycount))
 * @param times 重试次数
 */
export const retryFunction = (fn: (r: any) => Promise<any>, times = 8, inr = 500) => {
    return new Promise((resolve, reject) => {
        let retryCount = 0;
        (async function loopFn() {
            if (retryCount < times) {
                retryCount++;
                try {
                    let { result, status, info } = await fn?.(retryCount);
                    if (!!result && !status) {
                        resolve(result);
                    } else {
                        throw info;
                    }
                } catch (error) {
                    setTimeout(loopFn, inr);
                }
            } else {
                resolve(null);
            }
        })();
    });
};

/**
 * 获取公众号信息
 * @param orderToken 订单号
 * @returns
 */
export const getChatGzhService = (orderToken): Promise<any> =>
    new Promise((resolve, reject) => {
        getOrderGZHInfo({ order_token: orderToken })
            .then((res: any) => {
                const { status, result, info } = res;
                if (!status) {
                    resolve(result);
                } else {
                    resolve(window['sourceInfo']);
                }
            })
            .catch(e => {
                reject(window['sourceInfo']);
            });
    });

/**
 * 获取助手判断跳转
 * @param guideWordType 模板类型 获取助教：3
 * @param teacherInfo 助教信息
 */
export const getAssistantJump = (guideWordType, teacherInfo) => {
    if (guideWordType === 3 && teacherInfo.weChatQrCode) {
        window.location.href = teacherInfo.weChatQrCode
    }
};